<div class="modal active">
  <div class="modal__container modal__container--sm">
    <div class="fields">
      <h2>SAAM Traffic Density Import</h2>
      <div class="close" (click)="bsModalRef.hide()"><img src="/assets/img/close-white.svg" alt="" /></div>
      <div class="fields__container">
        <form autocomplete="off"  name="ngSAAMTrafficForm" #ngForm="ngForm" id="SAAMTrafficForm" class="active" >
          <div class="fields__block">
            <div class="fields__block__section">
              <p>Please enter a name for the layer:</p>
              <div class="input-fields">

                  <input type="text" (change)="changeLayerName($event.target.value)" name="layerName">
              </div>
            </div>
            <div class="fields__btn">
              <button class="blue" (click)="submit()">
                Ok
              </button>
              <button class="gray" (click)="bsModalRef.hide()">
                Cancel
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
